var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container content-node image-bgcolor"},[_c('div',{staticClass:"col-12"},[_c('SetImage',{attrs:{"set":_vm.set,"getApiHost":_vm.getApiHost,"mode":"full"}}),_c('SetList',{attrs:{"currentItem":_vm.set.currentItem,"items":_vm.set.items}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }